module.exports = __webpack_public_path__ + "img/airplane-ticket.30be2be9.png";